import React, { PureComponent } from 'react';
import classnames from 'classnames';

import './stat-box.scss';

interface Props{
    title:string,
    value:string,
    risk:'low' | 'medium' | 'high' | 'none'
}
 
class StatBox extends PureComponent<Props> {
    static defaultProps = {
        risk:'none'
    }
    render() {
        return (
            <div className={classnames({
                'stat-box':true,
            })}>
                <h3 className='stat-box-title'>{this.props.title}</h3>
                <span className={classnames({'stat-box-value':true,[this.props.risk]:true})}>{this.props.value}</span>
            </div>
        );
    }
}

export default StatBox;